/**
 * KinKen Kost Elite - Internationalization (i18n)
 * 
 * Usage:
 * 1. Wrap your app with LanguageProvider in layout.tsx
 * 2. Use useLanguage() hook to get current language and setLanguage function
 * 3. Use useTranslations() hook to get the full translations object
 * 
 * Example:
 * ```tsx
 * import { useLanguage, useTranslations } from '@/lib/i18n';
 * 
 * function MyComponent() {
 *   const { language, setLanguage } = useLanguage();
 *   const t = useTranslations();
 *   return <h1>{t.nav.home}</h1>;
 * }
 * ```
 */

// Export context and hooks
export {
  LanguageProvider,
  useLanguage,
  useTranslations,
  useTranslation,
  type Language,
} from "./context";

// Export type for translations
export type { Translations } from "./translations/id";

// Export translations for direct access if needed
export { default as idTranslations } from "./translations/id";
export { default as enTranslations } from "./translations/en";

// Supported languages
export const SUPPORTED_LANGUAGES = ["id", "en"] as const;

// Language display names
export const LANGUAGE_NAMES: Record<string, { native: string; english: string }> = {
  id: { native: "Indonesia", english: "Indonesian" },
  en: { native: "English", english: "English" },
};

// Helper to get language flag emoji
export const LANGUAGE_FLAGS: Record<string, string> = {
  id: "🇮🇩",
  en: "🇬🇧",
};
